import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { fromCandidate } from 'src/app/reducers/candidate.reducer';
import { Candidate } from 'src/app/models/candidate.model';
import { UtilsService } from 'src/app/services/utils.service';
import { NavigationEnd, Router } from '@angular/router';
import { Invitation, InvitationLite } from 'src/app/models/invitation.model';
import { CustomSelectService } from 'src/app/services/customSelect.service';
import { Test } from 'src/app/models/test.model';
import { fromTest } from 'src/app/reducers/test.reducer';
import { QuestionService } from 'src/app/services/question.service';
import { setQuestion } from 'src/app/actions/question.actions';
import { Question } from 'src/app/models/question.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'ct-candidate-header',
  templateUrl: './candidate-header.component.html',
  styleUrls: ['./candidate-header.component.scss']
})
export class CandidateHeaderComponent implements OnInit, AfterViewInit {

  candidate$: Observable<Candidate>;
  test$: Observable<Test>;
  question$: Observable<Question>;

  currentCandidate: Candidate;
  currentLanguage: string;
  currentInvitation: InvitationLite | Invitation;
  languagesNotSelected;

  private currentTest: Test;
  private currentQuestion: Question;

  constructor(
    private store: Store,
    private router: Router,
    public utilsService: UtilsService,
    private cdRef: ChangeDetectorRef,
    public customSelectService: CustomSelectService,
    private questionService: QuestionService,
    public translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.candidate$ = this.store.pipe(select(fromCandidate.selectCandidateState));
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.subscribe(test => {
      this.currentTest = test;
      this.currentLanguage = this.utilsService.getLanguageFromLanguageId(test?.invitation.languageId);
    });

    this.question$.subscribe(question => {
      this.currentQuestion = question;
    });

    this.candidate$.subscribe(candidate => {
      if (candidate) {
        this.currentCandidate = candidate;

        const token = this.router.url.split('/')[3];
        // Si viene desde la home tendrá invitations Lite si esta en el test tendra invitations pero solo con 1 (la del test)
        if (candidate.invitationsLite) {
          this.currentInvitation = candidate.invitationsLite?.find(invitation => invitation.token === token);
        } else if (candidate.invitations) {
          this.currentInvitation = candidate.invitations[0];
        }
      }
    });

    this.translateService.onLangChange.subscribe(res => this.currentLanguage = res.lang);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // comprobamos la situaicón en la que se encuentra  para mostrar la versión correspondiente
      this.utilsService.checkFeature();
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.utilsService.checkFeature();
        }
      });
      this.cdRef.detectChanges();
    }, 100);
  }

  changeLanguage(language) {
    this.utilsService.changeLanguage(language, this.currentCandidate.id).subscribe(res => {
      // Refrescamos la pregunta en caso de tener prueba en marcha.
      if (this.currentTest != null && this.currentQuestion?.questions.length) {
        this.questionService.getNextQuestion(this.currentTest.token).subscribe(questions => {
          this.store.dispatch(setQuestion(questions));
        }, error => {
          console.log(error);
        });
      }
      this.currentLanguage = language;
    });
  }

  /**
   * muestra/oculta el sleccionable de idiomas responsive
   */
  public toogleLanguageSelect(action: string) {
    // actualizamos de los idiomas no seleccionados
    this.languagesNotSelected = this.utilsService.getLanguagesNotSelected(this.currentInvitation?.clientId);

    // se ejecuta la cción que corresponda
    switch (action) {
      case 'toogle':
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
      case 'false':
        this.customSelectService.toogleLanguageSelect('false');
        break;
      default:
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
    }
  }

}
